import { AxiosInstance } from 'axios'

import { DefaultApiFactory } from '../generated/iam'

export const iamDefaultApiFactory = (instance: AxiosInstance) => {
  return DefaultApiFactory(undefined, '', instance)
}
